import { render, staticRenderFns } from "./TestKitList.vue?vue&type=template&id=717b8aa4&scoped=true"
import script from "./TestKitList.vue?vue&type=script&lang=js"
export * from "./TestKitList.vue?vue&type=script&lang=js"
import style0 from "./TestKitList.vue?vue&type=style&index=0&id=717b8aa4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "717b8aa4",
  null
  
)

export default component.exports